import React, { useState, useEffect } from 'react';
import api from '../services/api';

function Lexemes() {
  const [lexemes, setLexemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    global_index: '',
    concept_key: '',
    difficulty: 'beginner',
    category: 'general'
  });
  const [message, setMessage] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchLexemes();
  }, [page]);

  const fetchLexemes = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/admin/lexemes?page=${page}&limit=20`);
      setLexemes(response.data);
      setTotalPages(response.pages || 1);
    } catch (error) {
      console.error('Failed to fetch lexemes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/admin/lexemes', {
        ...formData,
        global_index: parseInt(formData.global_index)
      });
      setMessage({ type: 'success', text: 'Lexeme created successfully!' });
      setShowForm(false);
      setFormData({ global_index: '', concept_key: '', difficulty: 'beginner', category: 'general' });
      fetchLexemes();
    } catch (error) {
      setMessage({ type: 'error', text: error.message });
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Lexemes</h1>
        <p className="page-subtitle">Manage word concepts with global indexes</p>
      </div>

      {message && (
        <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-error'}`}>
          {message.text}
        </div>
      )}

      <div style={{ marginBottom: '20px' }}>
        <button
          className="btn btn-primary"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? 'Cancel' : '+ Add Lexeme'}
        </button>
      </div>

      {showForm && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '16px' }}>Add New Lexeme</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Global Index</label>
                <input
                  type="number"
                  className="form-input"
                  value={formData.global_index}
                  onChange={(e) => setFormData({ ...formData, global_index: e.target.value })}
                  min="1"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Concept Key</label>
                <input
                  type="text"
                  className="form-input"
                  value={formData.concept_key}
                  onChange={(e) => setFormData({ ...formData, concept_key: e.target.value.toUpperCase() })}
                  placeholder="CAT"
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Difficulty</label>
                <select
                  className="form-input"
                  value={formData.difficulty}
                  onChange={(e) => setFormData({ ...formData, difficulty: e.target.value })}
                >
                  <option value="beginner">Beginner</option>
                  <option value="intermediate">Intermediate</option>
                  <option value="advanced">Advanced</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Category</label>
                <input
                  type="text"
                  className="form-input"
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                  placeholder="animals, food, etc."
                />
              </div>
            </div>

            <button type="submit" className="btn btn-primary">
              Create Lexeme
            </button>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Index</th>
              <th>Concept Key</th>
              <th>Difficulty</th>
              <th>Category</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {lexemes.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: '40px' }}>
                  No lexemes found
                </td>
              </tr>
            ) : (
              lexemes.map((lexeme) => (
                <tr key={lexeme._id}>
                  <td><strong>#{lexeme.global_index}</strong></td>
                  <td>{lexeme.concept_key}</td>
                  <td>
                    <span className={`badge badge-${
                      lexeme.difficulty === 'beginner' ? 'success' :
                      lexeme.difficulty === 'intermediate' ? 'warning' : 'danger'
                    }`}>
                      {lexeme.difficulty}
                    </span>
                  </td>
                  <td>{lexeme.category}</td>
                  <td>
                    <button className="btn-icon" title="Edit">✏️</button>
                    <button className="btn-icon" title="Delete">🗑️</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {totalPages > 1 && (
          <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '8px' }}>
            <button
              className="btn btn-secondary"
              onClick={() => setPage(Math.max(1, page - 1))}
              disabled={page === 1}
            >
              Previous
            </button>
            <span style={{ padding: '12px 16px' }}>
              Page {page} of {totalPages}
            </span>
            <button
              className="btn btn-secondary"
              onClick={() => setPage(Math.min(totalPages, page + 1))}
              disabled={page === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Lexemes;

